import { render, staticRenderFns } from "./DeveloperEditHouseItems.vue?vue&type=template&id=613aa8fc&"
import script from "./DeveloperEditHouseItems.vue?vue&type=script&lang=js&"
export * from "./DeveloperEditHouseItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports